import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class PackageService {

  constructor(private http: HttpClient) { }

  getAllPackage(data: any): Observable<any> {
    return this.http.post(environment.getAllPackages, data);
  }

  createPackage(data: any): Observable<any> {
    return this.http.post(environment.createPackage, data);
  }

  updatePackage(data: any): Observable<any> {
    return this.http.post(environment.updatePackage, data);
  }

  deletePackage(data: any): Observable<any> {
    return this.http.post(environment.deletePackage, data);
  }

}